import {customElement, bindable, inject, LogManager, BindingEngine} from 'aurelia-framework';
import {Client} from '../api/client';
import * as _ from 'lodash';
import {LocaleService} from "../i18n/locale-service";
import {I18N} from 'aurelia-i18n';
import {ColumnLoader} from "./column-loader";
import {UserClient} from "../api/user-client";

const logger = LogManager.getLogger('object-display');

/**
 * Class to display an object or a list of objects as a table (label value)
 */
@customElement('object-display')
@inject(Client, I18N, ColumnLoader, UserClient, BindingEngine)
export class ObjectDisplay
{
    @bindable object;
    @bindable properties = [];
    @bindable showColumnTitles = true;

    showWithoutPermission = false;

    constructor(client, i18n, columnLoader, userClient, bindingEngine)
    {
        this.client = client;
        this.i18n = i18n;
        this.columnLoader = columnLoader;

        this.userClient = userClient;
        this.bindingEngine = bindingEngine;

        this.showWithoutPermission = this.userClient.showWithoutPermission;

        // Observe changes in contentLocale
        this.subscription = this.bindingEngine.propertyObserver(this.userClient, 'showWithoutPermission')
            .subscribe((showWithoutPermission) => {
                this.showWithoutPermission = showWithoutPermission;
            });
    }

    dispose() {
        if (this.subscription) {
            this.subscription.dispose();
        }
    }

    async bind()
    {
        this.columns = await this.columnLoader.loadColumns(this.object, this.properties);
    }

    getNested(column, object) {
        if (!column.nestedProperty) {
            return object;
        }

        return _.get(object, column.nestedProperty);
    }

    isAllowedProperty(object, column) {

        let item = this.getNested(column, object);

        if (column.property && (item?.['@disallowedProperties'] ?? []).indexOf(column.property) > -1) {
            return false;
        }

        return true;
    }
}
